import React from 'react';

const SystemOutputFigure: React.FC = () => (
  <figure className="system-output-figure">
    <div className="system-output-comparison">
      <section className="system-output-panel">
        <header>
          <strong>Standard Linux</strong>
          <span>formatted for people</span>
        </header>
        <div className="system-output-terminal">
          <code className="system-output-command"><b>$</b> ps</code>
          <pre>{`  PID TTY          TIME CMD
 2154 pts/0    00:00:04 claude
 2219 pts/1    00:00:02 codex
 2297 ?        00:00:00 node`}</pre>
        </div>
      </section>

      <section className="system-output-panel system-output-panel--structured">
        <header>
          <strong>BoostOS</strong>
          <span>structured for agents</span>
        </header>
        <div className="system-output-terminal">
          <code className="system-output-command"><b>$</b> ps</code>
          <pre>{`[
  { "pid": 2154, "name": "claude", "cpu": 18.4, "memory_mb": 1840 },
  { "pid": 2219, "name": "codex",  "cpu": 7.2,  "memory_mb": 920 },
  { "pid": 2297, "name": "node",   "cpu": 1.1,  "memory_mb": 180 }
]`}</pre>
        </div>
      </section>
    </div>

    <figcaption>
      The same system state, exposed as a human-readable table or structured data an agent can use without parsing columns.
    </figcaption>
  </figure>
);

export default SystemOutputFigure;
